import { Component } from "react";
import * as React from "react";
import { sortYearGroupingsByIsAfterValues, YearGrouping } from "../models/SchoolWorkloadConfig";
import SdsYear from "../models/SdsYear";
import * as _ from "lodash";
import YearCard from "./pages/onboard/YearCard";
import { Link } from "office-ui-fabric-react";
import YearGroupingCard from "./pages/onboard/YearGroupingCard";

interface AssignSubjectYearsEditorProps {
    tenantId: string;
    schoolCode: string;
    sdsYears: SdsYear[];
    yearGroupingItems: YearGrouping[];
    onYearGroupingChange(yearGroups: YearGrouping[]): void;
}

interface AssignSubjectYearsEditorState {
    ungroupedYearNames: string[];
    itemBeingDragged?: string;
}

export default class AssignSubjectYears extends Component<AssignSubjectYearsEditorProps, AssignSubjectYearsEditorState>
{

    constructor(props: Readonly<AssignSubjectYearsEditorProps>) {
        super(props);
        this.state = {
            ungroupedYearNames: []
        }
    }

    componentDidUpdate(prevProps: Readonly<AssignSubjectYearsEditorProps>, prevState: Readonly<AssignSubjectYearsEditorState>, snapshot?: any) {
        if (this.props.yearGroupingItems !== prevProps.yearGroupingItems || this.props.sdsYears !== prevProps.sdsYears) {
            this.calculateYearGroupings();
        }
    }

    public componentDidMount() {
        this.calculateYearGroupings();
    }

    private calculateYearGroupings() {
        if (this.props.yearGroupingItems && this.props.sdsYears) {
            const allYearNames = this.props.sdsYears.map(sdsYear => sdsYear.yearName);
            const groupedYearNames = this.props.yearGroupingItems.reduce((acc: any, yearGrouping) => {
                return _.concat(acc, yearGrouping.years);
            }, [])

            const ungroupedYearNames = _.without(allYearNames, ...groupedYearNames)
            ungroupedYearNames.sort();
            this.setState({
                ungroupedYearNames
            });
        }

        return;
    }

    private onDrag = (itemBeingDragged: string) => {
        console.log(`Started dragging ${itemBeingDragged}`);

        this.setState({
            itemBeingDragged
            });
    }

    private onDrop = (itemDrop: YearGrouping) => {
        console.log(`Dropped onto ${itemDrop.name}`);

        this.addNewYearGrouping(itemDrop, this.state.itemBeingDragged!);

        this.setState({itemBeingDragged: undefined})
    }

    private addNewYearGrouping(yearGroupingItem: YearGrouping, yearGroupItem: string) {

        const newYearGroupings = _.without(this.props.yearGroupingItems, yearGroupingItem);

        yearGroupingItem.years = [...yearGroupingItem.years, yearGroupItem];
        newYearGroupings.push(yearGroupingItem);

        let sortedYearGroupings = sortYearGroupingsByIsAfterValues(newYearGroupings);

        this.props.onYearGroupingChange(sortedYearGroupings);
    }

    private removeYearFromGrouping = (yearGrouping: YearGrouping, yearName: string): void => {

        yearGrouping.years = _.without(yearGrouping.years, yearName)
        const yearGroupingItems = [...this.props.yearGroupingItems];

        this.props.onYearGroupingChange(yearGroupingItems);
    }

    public render() {

        const yearsInSchoolDataCards = this.state.ungroupedYearNames.map(year => {

            return <YearCard
                key={year}
                yearItem={year}
                onDragStart={() => { this.onDrag(year) }}
                onDragEnd={() => {
                    console.log(`Item dragging ended: ${year}`);
                    this.setState({ itemBeingDragged: undefined })
                }} />
        });

        const YearGroupingCards = this.props.yearGroupingItems.sort().map(year => {

            const yearsInYearGrouping = year.years.map(y => <li key={y}>{y}<Link onClick={() => {this.removeYearFromGrouping(year, y)}}>(Remove)</Link></li>);

            return <YearGroupingCard
                key={year.name}
                className={"flex-column"}
                onDrop={() => {this.onDrop(year)}}
                yearGroupingItem={year}
            >
                <ul>{yearsInYearGrouping}</ul>
            </YearGroupingCard>
        });

        return (
            <div className={"flex-column"}>
                <div className={"flex-row flex--justify-content-center"}>
                    {"Drag and drop the years from the right column onto the corrosponding years in the left column"}
                </div>
                <div className="flex-row">
                    <div className={"flow-row flex-item--flex-2"}>
                        <h3>Year Groupings</h3>
                        {YearGroupingCards}
                    </div>
                    <div className={"flex-item--flex-2"}>
                        <h3>Years in school data</h3>
                        {yearsInSchoolDataCards}
                    </div>
                </div>
            </div>
        );
    }
}